import type { UserInfoResponse } from '@logto/vue'

type TokenResult = {
  error?: Error
  token: string | null
}

type UserInfoResult = {
  error?: Error
  user: UserInfoResponse | null
}

type TokenFetcher = (resource?: string) => Promise<TokenResult>
type UserInfoFetcher = () => Promise<UserInfoResult>
type AuthStateReader = () => boolean

type LogtoBridgeBindings = {
  getAccessTokenResult: TokenFetcher
  fetchUserInfoResult: UserInfoFetcher
  fetchUserInfoLatestResult: UserInfoFetcher
  isAuthenticated: AuthStateReader
}

let bindings: LogtoBridgeBindings | null = null

export const setLogtoBridgeBindings = (nextBindings: LogtoBridgeBindings) => {
  bindings = nextBindings
}

export const logtoBridge = {
  isReady: () => Boolean(bindings),
  isAuthenticated: () => bindings?.isAuthenticated() ?? false,
  getAccessTokenResult: async (resource?: string) => {
    if (!bindings) return { token: null }
    return bindings.getAccessTokenResult(resource)
  },
  fetchUserInfoResult: async () => {
    if (!bindings) return { user: null }
    return bindings.fetchUserInfoResult()
  },
  fetchUserInfoLatestResult: async () => {
    if (!bindings) return { user: null }
    return bindings.fetchUserInfoLatestResult()
  },
}
